// @ts-nocheck

import { ReactNode } from "react";
import { useCookies } from "react-cookie";
import { Navigate } from "react-router-dom";

interface ProtectedRouteProps {
  children: ReactNode;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const [cookies] = useCookies(["isLoggedInKIQ"]);
  
  // Check for authentication token as fallback
  const hasToken = localStorage.getItem("auth_token");
  const isAuthenticated = cookies.isLoggedInKIQ || hasToken;
  
  console.log("🛡️ [PROTECTED ROUTE] Auth check:", {
    cookieAuth: cookies.isLoggedInKIQ,
    hasToken: !!hasToken,
    isAuthenticated
  });

  if (!isAuthenticated) {
    console.log("🚪 [PROTECTED ROUTE] Not authenticated, redirecting to sign-in");
    return <Navigate to="/sign-in" />;
  }

  return children;
};

export default ProtectedRoute;
